import rootReducer from "../reducers";

import { applyMiddleware, compose, createStore } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default (initialState, history) => {
  return createStore(
    connectRouter(history)(rootReducer),
    initialState,
    composeEnhancers(
      applyMiddleware(
        routerMiddleware(history)
      ),
    )
  );
};



// WEBPACK FOOTER //
// ./src/store/configure-store.js